export default __webpack_public_path__ + "static/media/send-icon.c5d39dde.svg";